import { render, staticRenderFns } from "./ContainerReimagine.vue?vue&type=template&id=0f8960a0&scoped=true&"
import script from "./ContainerReimagine.vue?vue&type=script&lang=js&"
export * from "./ContainerReimagine.vue?vue&type=script&lang=js&"
import style0 from "./ContainerReimagine.vue?vue&type=style&index=0&id=0f8960a0&lang=scss&scoped=true&"
import style1 from "./ContainerReimagine.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8960a0",
  null
  
)

export default component.exports